module.exports = __webpack_public_path__ + "images/SteeringWheel.3b8a84828a0b40fa27a51ed6b64c09b4.png";